export default "__VITE_ASSET__CECLNFzG__"